<template>
    <div
        class="modal fade"
        id="contentModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="contentModal"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered d2-modal">
            <div class="modal-content" v-if="isLoad != false">
                <div class="modal-header" v-bind:style="{ backgroundImage: 'url(' + details.cover_img + ')' }">
                
                <button
                  id="close"
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                    <span aria-hidden="true" id="close">&times;</span>
                </button>
                </div>
                <div class="modal-body">
                    
                  <div class="d2-appItem__thumb">
                                  <div v-if="details.content_type === 'application/x-zip-compressed'" class="htmlBadge">
                                        <img src="../../assets/gamebox/imgs/html5-badge.png"/>
                                    </div>
                                    <img id="thumbnail" :src="details.thumbnail_url" />
                            </div>
                            <h2 class="d2-h2" id="cont_name">
                                <!-- <span v-if="details[`cont_name_${lang_gamebox}`] != ''">{{details[`cont_name_${lang_gamebox}`]}}</span>
                                <span v-else>{{details[`cont_name_english`]}}</span> -->
                            </h2>
                        <star-rating
                            :inline="true"
                            :star-size="24"
                            :read-only="true"
                            :increment="0.01"
                            active-color="#FFCF00"
                            :show-rating="false"
                            :border-width="2"
                            border-color="#FFCF00"
                            :rounded-corners="false"
                            inactive-color="transparent"
                            :star-points="[
                                23,
                                2,
                                14,
                                17,
                                0,
                                19,
                                10,
                                34,
                                7,
                                50,
                                23,
                                43,
                                38,
                                50,
                                36,
                                34,
                                46,
                                19,
                                31,
                                17
                            ]"
                            :rating="Number(details.rating)"
                        ></star-rating>
                         <div class="d2-modal__row">
                                <span>{{ $t("platform") }}: <span id="platform"></span></span>
                            </div>
                            <div class="d2-modal__row">
                                <p class="d2-ptxt" id="description"></p>
                            </div>
                          
                  
                </div>
                <div class="modal-footer">
                    <div class="d2-modal__row">
                                <!-- <button class="mobiBtn" @click="subscribeContent([details.raw_file_url, details.subcategory])"><span v-if="details.subcategory === 'HTML5 Games'">{{ $t("play") }}</span> <span v-if="details.subcategory !== 'HTML5 Games'">{{ $t("download") }}</span></button> -->
                                <div v-if="details.content_type === 'application/url'">
                                    <button class="d2-button" @click="subContent_gamebox([details.content_detail, details.content_type, details.id])">
                                    <span>{{ $t("play") }}</span>
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="d2-button" @click="subContent_gamebox([details.raw_file_url, details.content_type, details.id])">
                                        <span v-if="details.content_type === 'application/x-zip-compressed'">{{ $t("play") }}</span>
                                        <span v-else>{{ $t("download") }}</span>
                                    </button>
                                </div>
                            </div>
                <!-- <button
                    type="button"
                    class="d2-button"
                    data-dismiss="modal"
                    v-on:click="close()"
                >
                    {{ $t("close") }}
                </button> -->
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Plyr from "plyr";
import gamebox_route from "../../router/gamebox";
import { mapActions, mapGetters } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);

export default {
  data() {
    return {
      id: this.$route.params.id,
      details: {},
      detailsAR: {},
      contentCoverImg: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      srcUrl: "http://cdn.grabmobi.com.s3.amazonaws.com/portal/newcontent",
      isLoad: false,
      lightBoxCurrentPic: "",
      lightBoxCurrentId: null,
      lightBoxToggle: false
    };
  },
  components:{
    StarRating
  },
  computed: mapGetters(["lang_gamebox", "host_gamebox", "country_gamebox"]),
  mounted() {
    document.addEventListener("click", e => {
      if (e.target.id == "contentModal" || e.target.id == "close") {
        this.details = {};
        this.isLoad = false;
      }
    });

    this.$root.$on("getDetail", id => {
      this.getDetail(id);
    });
  },
  methods: {
    ...mapActions(["subContent_gamebox"]),
    getDetail(id) {
      let live = `http://cook.grabmobi.com`;
      let local = `http://[::1]/PuretechGlobalContentPortal`;

      //post view detail
      axios.post(`${live}/api/newcontents_statistic`, {
        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
        country: this.country_gamebox,
        product: 'gamebox',
        content_id: id,
        type: "view"
      })

      axios.get(`${live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=${id}&category=&subcategory=&limit=100&offset=0&domain=${this.host_gamebox}`)
        .then(res => {
          let data = res.data.data[0];

          let sc = data.screenshot.split(",");
          let sc_temp = [];
          for (let i = 0; i < sc.length; i++) {
            sc_temp.push({ id: i, url: `${this.srcUrl}/${data.id}/${sc[i]}` });
          }

          data.screenshot = sc_temp;

          this.contentCoverImg = data.cover_img;

          data.titleSub_english = data.subcategory;

          if (data.subcategory_translate != null) {
            let sub_trans = JSON.parse(data.subcategory_translate);
            let sub_icon = JSON.parse(data.subcategory_icon);

            let trans_len = Object.keys(sub_trans).length;
            let trans_arr = Object.keys(sub_trans);
            for (let i = 0; i < trans_len; i++) {
              data["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
            }
          }

          setTimeout(() => {
            this.details = data;
            console.log(this.details)
            this.isLoad = true;
            this.getTranslate(data, this.lang_gamebox);
          }, 0);
        });
    },
    getTranslate(data, lang) {
      setTimeout(() => {
        if (lang != "") {
          if (lang != "english") {
            if (data[`cont_name_${lang}`] != "") {
              document.getElementById("cont_name").innerHTML =
                data[`cont_name_${lang}`];
            } else {
              document.getElementById("cont_name").innerHTML =
                data[`cont_name_english`];
            }

            if (data[`desc_${lang}`] != "") {
              document.getElementById("description").innerHTML = `<span>${
                data[`desc_${lang}`]
              }</span>`;
            } else {
              document.getElementById("description").innerHTML = `<span>${
                data[`desc_english`]
              }</span>`;
            }
          } else {
            document.getElementById("cont_name").innerHTML =
              data[`cont_name_english`];
            document.getElementById("description").innerHTML = `<span>${
              data[`desc_english`]
            }</span>`;
          }

          let platform = "";
          let plat = require(`../../locales/gamebox/${lang}.json`);
          let file = data.content_detail.split(".");
          if (file[1] == "apk" || data.content_detail.includes("apk")) {
            platform = plat["android"];
          } else {
            platform = plat["mobile_computer"];
          }
          document
            .getElementById("thumbnail")
            .setAttribute("src", data["thumbnail_url"]);
          document.getElementById("platform").innerHTML = platform;
        }
      }, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.d2-modal {
  .modal-content {
    background-color: #fff;
  }
  .modal-header {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 220px;
    border: 0;
    position: relative;
    &::before {
      content: "";
      display: block;
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      background: rgb(0, 0, 0);
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      height: 100%;
    }
  }
  .d2-appItem__thumb {
    margin: -70px auto 15px;
  }
  .d2-h2,
  span,
  .d2-ptxt {
    color: #000;
  }
  .modal-header .close {
    position: relative;
    outline: none;
    opacity: 1;
    text-shadow: none;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .modal-header .close span,
  .d2-button span {
    color: #fff;
  }
  .modal-footer {
    display: block;
    align-items: inherit;
    justify-content: inherit;
  }
}
.d2-modal__row {
  margin: 15px 0px;
}
/*##### Arabic layout Styles#####*/

.ar_layout .modal-body {
  text-align: right;
  direction: rtl;
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/DetailModal.vue